import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { TransactionType } from './transaction-types';
import { logAndThrowError } from '../../utils/errors';
import { z } from 'zod';
// Split schema
export const transactionSplitSchema = z.object({
    id: z.string().uuid(),
    bucketId: z.string().uuid(),
    amount: z.coerce.number(),
});
// Split request schema
export const transactionSplitRequestSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
    splits: z.array(transactionSplitSchema).min(2, 'At least one split is required'),
});
export const useSplitTransactionApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['transactions', budgetId];
    // api call
    const splitTransactionApi = async (data) => {
        await api.post('/account/transaction/split', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No transactions data found');
        }
        // make a copy of the existing list
        let updatedTransactions = [...oldData];
        // find the original transaction
        const originalTransaction = updatedTransactions.find((t) => t.id === request.id);
        if (!originalTransaction) {
            return oldData;
        }
        // decide which splitId to propagate
        const splitId = originalTransaction.splitId ?? originalTransaction.id;
        // remove original
        updatedTransactions = updatedTransactions.filter((t) => t.id !== request.id);
        // create new split transactions with splitId set
        const splitTransactions = request.splits.map((split) => ({
            ...originalTransaction,
            id: split.id,
            bucketId: split.bucketId,
            inflow: originalTransaction.outflow != null ? undefined : split.amount,
            outflow: originalTransaction.outflow != null ? split.amount : undefined,
            type: TransactionType.TRANSACTION,
            transferAccountId: undefined,
            transferTransactionId: undefined,
            splitId: splitId,
        }));
        updatedTransactions.push(...splitTransactions);
        updatedTransactions.sort((a, b) => b.dateEpoch - a.dateEpoch || a.id.localeCompare(b.id));
        return updatedTransactions;
    };
    return useQueryMutation(splitTransactionApi, queryKey, onMutate, options);
};
